import { CampaignFacetsResponse } from 'clients/CampaignsClient/CampaignsClient.types';
import { memoize } from 'lodash';

export const generateBuckets = memoize((facetsResponse: CampaignFacetsResponse) =>
  Object.fromEntries(
    facetsResponse.aggregations.source_facets.source_facet.buckets.map((bucket) => [bucket.key, bucket.doc_count]),
  ),
);
